import ApiClient from './ApiClient';

class AutomationTextsAPI extends ApiClient {
  constructor() {
    super('automation_texts', { accountScoped: true });
  }
}

export default new AutomationTextsAPI();
